import { enUS } from 'date-fns/locale';

/**
 * Custom Locale for DatePicker Component
 *
 * This module customizes the `enUS` locale from `date-fns` to override the
 * day names in the DatePicker with single-character short names ('S', 'M', 'T', etc.).
 */
const customLocale = {
  ...enUS,
  localize: {
    ...enUS.localize,
    day: (narrowDay) => {
      const shortNames = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
      return shortNames[narrowDay];
    },
  },
};

export default customLocale;
